import React from 'react';
import cn from 'classnames';

import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  activeIf?: boolean;
  centered?: boolean;
  className?: string;
  spinnerClassName?: string;
  color?: string;
  spinnerStyles?: {};
  style?: {};
};

function Spinner({
  activeIf = false,
  color = '#28a745',
  style,
  className = '',
  spinnerStyles,
  spinnerClassName = '',
  centered = true,
}: Props) {
  const { tr } = useTranslation();

  if (!activeIf) return null;

  return (
    <h6
      className={cn(
        `text-center d-flex align-self-center align-items-center flex-column justify-content-center mb-0 ${className}`,
        {
          'flex-fill': centered,
        }
      )}
      style={{ height: '100%', ...style }}
    >
      <div className={`spinner-border ${spinnerClassName}`} role="status" style={{ ...spinnerStyles, color }}>
        <span className="sr-only">{tr('perform.common.loading')}</span>
      </div>
    </h6>
  );
}

export default Spinner;
